import React, { useState } from "react";

import { Row, Input, Button, Tag } from "antd";

import { CloseOutlined } from "@ant-design/icons";

import styles from "./CooperateTag.module.css"; // CSS 모듈 임포트

function CooperateTag({ cooperateTagsList, setCooperateTagsList }) {
  // 현재 입력 중인 태그 이름, 배경색, 글자색을 위한 상태
  const [currentTagName, setCurrentTagName] = useState("");
  const [currentTagBackgroundColor, setCurrentTagBackgroundColor] =
    useState("#383E44"); // 기본 배경색
  const [currentTagTextColor, setCurrentTagTextColor] = useState("#FFFFFF"); // 기본 글자색 (대비 잘 되도록 흰색으로 설정)

  // 태그 이름 입력 변경 핸들러
  const handleTagNameChange = (e) => {
    setCurrentTagName(e.target.value);
  };

  // 색상 입력 변경 핸들러 (재사용 가능하도록 일반화)
  const handleColorChange = (e, setColorState) => {
    const value = e.target.value;
    // HEX 코드 유효성 검사: #을 포함한 3 또는 6자리 16진수 숫자, 또는 단순히 #만 입력된 경우 허용
    if (/^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/.test(value) || value === "#") {
      setColorState(value);
    }
    // else {
    //   console.warn("유효하지 않은 색상 형식입니다. #RRGGBB 또는 #RGB 형식이어야 합니다.");
    // }
  };

  // 태그 추가 버튼 클릭 핸들러
  const handleAddTag = () => {
    if (currentTagName.trim() === "") {
      alert("태그 이름을 입력해주세요.");
      return;
    }
    // 색상 유효성 검사 (추가 시점에 강제)
    if (!/^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/.test(currentTagBackgroundColor)) {
      alert("유효한 배경색 코드를 입력해주세요 (#RRGGBB 형식).");
      return;
    }
    if (!/^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/.test(currentTagTextColor)) {
      alert("유효한 글자색 코드를 입력해주세요 (#RRGGBB 형식).");
      return;
    }
    if (cooperateTagsList.length >= 3) {
      alert("태그는 최대 3개까지만 추가할 수 있습니다.");
      return; // 3개 이상이면 함수 종료, 태그 추가 방지
    }

    // 새로운 태그 객체 생성 및 리스트에 추가
    setCooperateTagsList([
      ...cooperateTagsList,
      {
        id: Date.now(),
        title: currentTagName.trim(),
        backgroundColor: currentTagBackgroundColor, // 배경색 저장
        textColor: currentTagTextColor, // 글자색 저장
      },
    ]);

    // 입력 필드 초기화
    setCurrentTagName("");
    setCurrentTagBackgroundColor("#383E44"); // 추가 후 기본 배경색으로 재설정
    setCurrentTagTextColor("#FFFFFF"); // 추가 후 기본 글자색으로 재설정
  };

  // 태그 삭제 핸들러
  const handleRemoveTag = (idToRemove) => {
    setCooperateTagsList(
      cooperateTagsList.filter((tag) => tag.id !== idToRemove),
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <Row
        className={styles.productRegisterBorderBox}
        wrap={false}
        style={{ border: 0, width: "100%" }}
      >
        {/* 태그 이름 입력 필드 */}
        <div className={styles.tagInputContainer}>
          <Input
            value={currentTagName}
            placeholder="태그 이름을 입력하세요"
            onChange={handleTagNameChange}
            style={{ flex: 1 }}
          />

          {/* 태그 배경색 입력 필드 */}
          <Input
            type="color"
            value={currentTagBackgroundColor}
            onChange={(e) => handleColorChange(e, setCurrentTagBackgroundColor)}
            title="배경색 선택" // 툴팁 추가
            style={{ width: 50, padding: 0 }}
          />
          <Input
            value={currentTagBackgroundColor}
            onChange={(e) => handleColorChange(e, setCurrentTagBackgroundColor)}
            placeholder="#배경색"
            style={{ width: 100 }}
          />

          {/* 태그 글자색 입력 필드 */}
          <Input
            type="color"
            value={currentTagTextColor}
            onChange={(e) => handleColorChange(e, setCurrentTagTextColor)}
            title="글자색 선택" // 툴팁 추가
            style={{ width: 50, padding: 0 }}
          />
          <Input
            value={currentTagTextColor}
            onChange={(e) => handleColorChange(e, setCurrentTagTextColor)}
            placeholder="#글자색"
            style={{ width: 100 }}
          />

          {/* 태그 추가 버튼 */}
          <Button type="primary" onClick={handleAddTag}>
            추가
          </Button>
        </div>
      </Row>

      {/* 추가된 태그들을 표시하는 부분 */}
      <div className={styles.addedTagsListWrapper}>
        {" "}
        {/* 새롭게 감싸는 div 추가 */}
        {cooperateTagsList.map((tag) => (
          // 각 태그를 Ant Design의 Row로 감싸면 항상 새 줄에 표시됩니다.
          <Row key={tag.id} style={{ marginBottom: 8 }} wrap={false}>
            {" "}
            {/* 각 태그마다 Row 추가 */}
            <Tag
              // color prop 대신 style을 직접 사용하여 배경색과 글자색 적용
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 8px",
                backgroundColor: tag.backgroundColor, // 배경색
                color: tag.textColor, // 글자색
              }}
              closable
              onClose={() => handleRemoveTag(tag.id)}
            >
              {tag.title}
            </Tag>
          </Row>
        ))}
        {cooperateTagsList.length === 0 && (
          <p style={{ color: "#888" }}>아직 추가된 태그가 없습니다.</p>
        )}
      </div>
    </div>
  );
}

export default CooperateTag;
